
const digest = 'd5ceb4e73c8d5b9816eb31c052e6699f493adac45a1d600e2e6f09a4c2796b1a';
const classes = {"wrapper":"_wrapper_1kht4_1"};
const css = `._wrapper_1kht4_1 {
  height: 100%;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  